/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CertificateCircledIcon = /*#__PURE__*/ createSvgIcon(
  'CertificateCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M13.08 8.769l-.856.652c-.043.034-.088.034-.135 0-.046-.034-.061-.077-.044-.128l.332-1.061-.882-.69c-.043-.034-.055-.077-.038-.128.017-.051.055-.077.115-.077h1.06l.333-1.048c.017-.051.056-.077.115-.077.06 0 .098.026.115.077l.333 1.048h1.06c.06 0 .099.026.116.077.017.051.004.094-.039.128l-.882.69.333 1.061c.017.051.002.094-.045.128s-.092.034-.134 0l-.857-.652z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.833 7.917a3.739 3.739 0 01-1.142 2.694v2.548c0 .396-.363.691-.75.611l-1.96-.404-1.96.405a.624.624 0 01-.75-.612v-2.762a3.75 3.75 0 116.563-2.48zm-3.75 2.625a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zm0 1.125c.527 0 1.028-.109 1.483-.305v1.182l-1.585-.327-1.585.327v-1.278c.507.256 1.08.4 1.687.4z"
              fill="currentColor"
            />
            <path
              d="M8.77 6.042H4.459v8.25h11.813a.563.563 0 010 1.125H4.458c-.31 0-.574-.11-.794-.33-.22-.221-.33-.486-.33-.795v-8.25c0-.31.11-.575.33-.795.22-.22.485-.33.794-.33h4.313a.563.563 0 010 1.125z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default CertificateCircledIcon;
